export default function ShopPage () {
    return (
        <div>
            <p>shop</p>
        </div>
    )
}